import { render, staticRenderFns } from "./GenderSelectionImageButton.vue?vue&type=template&id=b1777e44&"
import script from "./GenderSelectionImageButton.vue?vue&type=script&lang=js&"
export * from "./GenderSelectionImageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports